import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GenderEnum} from '../../models/user';
import {ExpertListDTO} from '../../dtos/expert';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';

@Component({
  selector: 'app-card-expert',
  templateUrl: './card-expert.component.html',
  styleUrls: ['./card-expert.component.scss']
})
export class CardExpertComponent implements OnInit {

  @Input() active: boolean;
  @Input() withoutShadow: boolean;
  @Input() expert: ExpertListDTO;
  @Input() setGrayCard = false;
  @Output() profile: EventEmitter<boolean> = new EventEmitter<boolean>();

  gender: GenderEnum;
  constructor(
    public utilitiesService: UtilitiesService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Emite al componente padre cuando se quiere ver el perfil del experto.
   */
  onEmitViewProfile(): void {
    this.profile.emit(true);
  }
}
